import React, { Component } from 'react';
import { isEmpty, get, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import FileSaver from 'file-saver';
import { saveAs } from "file-saver";
import { endPoints } from "../../../constants/configuration";

import { PERMISSION } from '../../../constants/permission';
import { checkTablePermission, checkAddPermission } from '../../../utils/route-auth';

import Table from '../../../components/CustomTable';
import ModalConfirmation from '../../../components/ModalConfirmation';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';

import { mediaPlanListoptions } from './constant';

import {
    getIoListAllReportAction,
    deleteIoAction,
    getIoEditIdReportAction,
    addIoReportAction,
    getMediaplanPdfAction,
    getMediaPlanListAction
} from '../../../actions';

const Card = asyncRoute(() => import('../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../components/BreadCrumb'));

class index extends Component {

    constructor(props) {
        // console.log(props,"props form")
        super(props);
        this.state = {
            confirmationOpen: false,
            confirmationInfo: '',
            // optionsList: mediaPlanListoptions,
            mediaPlanListData: [],
            isCheckedRefresh: false
        }
    }

    // eslint-disable-next-line no-unused-react-component-methods/no-unused-react-component-methods
    async componentWillMount() {
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));


        const { history } = this.props;
        if (isEmpty(isAuthenticated)) {
            history.push(routes.preSignIn);
        }

        this.mediaList();
    }

    mediaList = async () => {
        const { tenantId, authToken, userId, getMediaPlanListAction, configurationList } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await getMediaPlanListAction({ tenantId, authToken, userId });
        if (status == "Success") {

            this.setState({ mediaPlanListData: responseList });
        }
    }

    updateStateForRefresh() {
        this.setState({ isCheckedRefresh: false })


    }
    disableButton() {
        this.setState({ isCheckedRefresh: true })

        setTimeout(() => {
            this.updateStateForRefresh();
        }, 60000)
    }

    refreshPdf = async () => {

        // setTimeout(async () => {
        // }, 0)
        this.disableButton();
        this.mediaList();

    }




    getIoListAll() {
        const { getIoListAllReportAction, tenantId, authToken, userId } = this.props;
        getIoListAllReportAction(tenantId, authToken, userId);

    }

    handleAction = (row, action) => {
        const { match, history } = this.props;
        if (action.type === 'download') {
            this.handleDownload(row, match, history);
        }
    };


    // handleDownload = async (row, action) => {
    //     const { authToken, userId, tenantId, getMediaplanPdfAction } = this.props
    //     const mediaplanName = row.name
    //     const {
    //         responseCode: { status = "" },
    //         response,
    //     } = await getMediaplanPdfAction({ tenantId, authToken, userId, mediaplanName })
    //     if (status == "Success") {
    //         let getURL = response.path;
    //         // fetch(getURL).then(response => {
    //         //     response.blob().then(blob => {
    //         //         // Creating new object of PDF file
    //         //         const fileURL = window.URL.createObjectURL(blob);
    //         //         // Setting various property values
    //         //         let alink = document.createElement('a');
    //         //         alink.href = fileURL;
    //         //         alink.download = `${mediaplanName}.pdf`;
    //         //         alink.click();
    //         //     })
    //         // })

    //     } else {
    //         let require = { action: { confirmationMessage: 'Media plan is not ready', type: 'error' } };
    //         this.toggleModal(require);
    //     }
    // }

    handleDownload = async (row, action) => {
        const { authToken, userId, tenantId, getMediaplanPdfAction } = this.props;
        const mediaplanName = row.name;
        const {
            responseCode: { status = "" },
            response,
        } = await getMediaplanPdfAction({ tenantId, authToken, userId, mediaplanName });
        
        if (status === "Success") {
            const getURL = response.path;
            // console.log("getURL", getURL);
    
            // Create an anchor element
            const link = document.createElement("a");
            link.href = getURL;
            link.target = "_blank"; // Open in a new tab
    
            // Use the download attribute to suggest a filename for the downloaded file
            link.setAttribute("download", `${mediaplanName}.pdf`);
    
            // Trigger a click on the anchor element to initiate the download
            link.click();
        } else {
            let require = { action: { confirmationMessage: 'Media plan is not ready', type: 'error' } };
            this.toggleModal(require);
        }
    }
    



    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
    };

    // eslint-disable-next-line no-unused-vars
    confirmationCallBack = (success, info) => {
        this.setState({ confirmationOpen: false });
    };

    render() {
        const { match, ioListAll, configurationList } = this.props;
        const { confirmationOpen, confirmationInfo, mediaPlanListData, optionsList, isCheckedRefresh } = this.state;

        const currencyList = get(configurationList.find(currency => currency.attrName === 'CURRENCY'), 'attributeValues', []);
        let ioList = ioListAll.map((item) => {
            item.budgetName = item.budget;
            if (item.currency && item.currency.length) {
                let currency = currencyList.find((itemCurrency) => itemCurrency.key == item.currency[0].currency);
                if (currency) {
                    item.budgetName = `${item.budget.toLocaleString()} (${currency.value})`;
                }
            }
            return item;
        });
        return (
            <>
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}
                <div className="main-panel ion">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        <div className="row mt-3">
                            {/* <Card>
                                {
                                    (checkAddPermission(PERMISSION.MEDIAPLAN.MEDIAPLAN.ADD)) && (
                                        <div className="float-right">
                                            <Link to={`${match.path}/${routes.mediaPlan.addMedia}`}> <button className="btn btn-primary"><i className="mdi mdi-plus"></i>Add New Media Plan</button></Link>
                                        </div>
                                    )
                                }
                            </Card> */}
                            <Card>
                                <div className='d-flex' style={{ justifyContent: 'end' }}>
                                    <button
                                        className="btn btn-outline-primary mr-3 MediaplanRefresh"
                                        onClick={(e) => this.refreshPdf()}
                                        type="button"
                                        style={{ height: 'fit-content' }}
                                        disabled={isCheckedRefresh}
                                    >
                                        <i className="mdi mdi-refresh"></i>
                                    </button>

                                    {
                                        (checkAddPermission(PERMISSION.MEDIAPLAN.MEDIAPLAN.ADD)) && (
                                            <div className="margin-list-adj mb-4">
                                                <Link to={`${match.path}/${routes.mediaPlan.addMedia}`}> <button className="btn btn-primary"><i className="mdi mdi-plus"></i>Media Plan</button></Link>
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="table-responsive">
                                    <Table
                                        options={mediaPlanListoptions}
                                        data={mediaPlanListData}
                                        handelAction={this.handleAction}
                                        pdfPath={true}
                                    />
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(connect(
    state => ({
        getUserPermissionList: get(state, 'app.getUserPermissionList', []),
        configurationList: get(state, 'app.configurationData.responseList', []),
        ioListAll: get(state, 'app.ioListAllReport.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', '')
    }),
    {
        getIoListAllReportAction,
        deleteIoAction,
        getIoEditIdReportAction,
        addIoReportAction,
        getMediaplanPdfAction,
        getMediaPlanListAction
    }
)(index));

// ----*  IO propTypes * ----
index.propTypes = {
    configurationList: PropTypes.array,
    ioListAll: PropTypes.array,
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
    getIoListAllReportAction: PropTypes.func,
    deleteIoAction: PropTypes.func,
};